// GtmLoader.js
import { connect } from 'react-redux';

import GtmLoader from '../component/GtmLoader.jsx';
import getMeData from '../selector/getMeData.js';

const mapStateToProps = state => {
  return {
    userId: getMeData(state, 'id'),
    username: getMeData(state, 'username'),
    clientId: getMeData(state, 'clientId'),
  };
};

export default connect(mapStateToProps)(GtmLoader);
